import React, {useContext} from 'react';
import {BridleContext} from '../BridleContextProvider';
import Buttons from '../components/Buttons';
import Page from '../components/Page';
import SectionInfo from '../components/SectionInfo';
import Toolbar from '../components/Toolbar';
import {getAttributesGroupedInDisplayOrder, getSortOrder, orderMap} from '../HelperFunctions';

const Noseband = () => {
    const {products, options} = useContext(BridleContext);
    const pieces = getSortOrder(products, orderMap.Noseband);
    const productId = options.Noseband.productId;
    const attributesInOrder = getAttributesGroupedInDisplayOrder(pieces.attributeValues);

    return (
        <div className="bridle-page-content">
            <Toolbar pageName="Noseband" />
            <SectionInfo section="Noseband" page="5" />
            <Page
                attributes={attributesInOrder}
                pageName="Noseband"
                pieces={pieces}
                productId={productId}
                sizeGuide="noseband"
            />
            <Buttons back="/cheekpiece" next="/reins" disableButton={productId === ''} />
        </div>
    );
};

export default Noseband;
